import { useContext } from "react";
import { ApiContext } from "../contexts/ApiContext";
import { QueryCallbacks } from "../shared/interfaces/ReactQuery";
import { useQuery } from "react-query";
import { PagedData } from "../shared/interfaces/ReportsAPIInterfaces";
import { DataTablePFSEvent } from "primereact/datatable";
import { ReportDocument } from "../shared/interfaces/ReportDocument";

export function usePagedReportsList(
  lazyState: DataTablePFSEvent,
  customerId?: number,
  companyId?: number,
  siteId?: number,
  callbacks?: QueryCallbacks<PagedData<ReportDocument[]>>,
) {
  const apiContext = useContext(ApiContext);

  return useQuery({
    queryKey: ["pagedReportsList", lazyState, customerId, companyId, siteId],
    queryFn: async () => {
      if (lazyState && customerId) {
        return await apiContext.utp2ReportsAPIs.getPagedReportsList(lazyState, customerId, companyId, siteId);
      }
    },
    onSuccess: callbacks?.onSuccess,
    onError: callbacks?.onError,
  });
}
